
import type { CurrencyKey } from '@/app/core/currency/interfaces/currency.types';

export const PRIVATE_CURRENCY_OPTIONS = [
  {
    key: 'cop',
    code: 'COP',
    label: 'MENU.CURRENCY.OPTION_COP',
  },
  {
    key: 'usd',
    code: 'USD',
    label: 'MENU.CURRENCY.OPTION_USD',
  },
] as const satisfies ReadonlyArray<{
  key: CurrencyKey;
  code: string;
  label: string;
}>;

export type PrivateCurrencyOption = (typeof PRIVATE_CURRENCY_OPTIONS)[number];